import type { ENVType } from '@/types/ENV'

export default {
  APP_URL: 'https://playerrating-qa-rbac.solaireresort.com/',

  // make sure to end url with a '/'
  API_URL: 'https://playerrating-qa-rbac-be.solaireresort.com/',
  MSAL_TENANT_ID: '9c1d6af6-94df-4a4c-9b70-26edaee05a21',
  MSAL_CLIENT_ID: 'fb4c8f8f-38ac-49ba-bdf4-03408164f576',
  MSAL_REDIRECT_URI: '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: '/',
  USE_KONG_API: false,
  TOKEN_API_URL: '',
  TOKEN_API_CLIENT_ID: '',
  TOKEN_API_CLIENT_SECRET: ''
} as ENVType
